module.exports = __webpack_public_path__ + "static/media/TharinduSenda.1b1ff02a.jpeg";